// Dedicated /small-business page content + pricing (SEK, excl. VAT — Stockholm market)
export const PRICING = {
  services: ["website", "video", "social", "ads"],
  websitePrice: "499 kr",
  plans: [
    { key: "starter", popular: false },
    { key: "growth", popular: true },
    { key: "pro", popular: false },
  ],
};

export const smePath = (locale) => {
  const p = { en: "/small-business", sv: "/se/small-business", da: "/dk/small-business", nb: "/no/small-business", fi: "/fi/small-business", is: "/is/small-business", de: "/de/small-business" };
  return p[locale] || "/small-business";
};

const en = {
  seoTitle: "NOWI for Small Business — Websites, Video & Social that win leads",
  seoDescription: "Websites, industry-grade video and social media managed by a dedicated person always reachable on WhatsApp. Pay as you go or subscribe. From Stockholm, for Europe.",
  badge: "For small & local businesses",
  h1: ["More customers.", "Less hassle."],
  sub: "More than websites, mobile apps, and industry-grade video—you get a dedicated partner committed to helping your business grow. Every project comes with an expert who understands your vision and is always just one message away.",
  ctaBook: "Book a free 15-min call",
  ctaWhats: "Chat on WhatsApp",
  trust: ["No jargon", "Fixed pricing for each service", "See it live in 2 weeks", "Cancel anytime*"],
  cancelNote: "*Excluding web apps and mobile apps.",
  apps: {
    title: "Mobile apps that keep customers coming back",
    sub: "Give people a reason to open your app every week.",
    items: [
      { t: "Digital punch cards", d: "Loyalty and stamp cards like the Pressbyrån app — buy nine, get the tenth free, right on the phone." },
      { t: "Location-based offers", d: "Detect when a customer is nearby, like Circle K, and send a timely fuel or coffee deal." },
      { t: "Push notifications", d: "Nudge customers with news, offers and reminders so your business stays top of mind." },
    ],
    note: "Brand examples shown for inspiration only — they are not built by NOWI.",
  },
  anniversary: {
    tag: "Anniversary offer",
    title: "We're celebrating — special launch discount",
    text: "To mark our anniversary, we're giving new customers a limited introductory discount on website subscriptions and packages. Message us to claim it before it's gone.",
    ends: "Offer ends in",
    cta: "Claim the offer",
  },
  whyTitle: "Why local businesses choose NOWI",
  why: [
    { t: "Built to win leads", d: "Every site and campaign is designed around one goal: more calls, bookings and sales." },
    { t: "A dedicated person", d: "One real human who knows your business and is reachable on WhatsApp whenever you need them." },
    { t: "Industry-grade video", d: "Scroll-stopping video and content produced to a standard usually reserved for big brands." },
  ],
  offerTitle: "Everything to grow online",
  offerSub: "Pick exactly what you need — or let us run it all for you.",
  offers: [
    { t: "Websites", d: "Fast, modern, mobile-first sites that turn visitors into customers." },
    { t: "Promo video", d: "Short, punchy videos for your site, ads and social feeds." },
    { t: "Social media", d: "Consistent, on-brand content that keeps you top of mind." },
    { t: "Ads & strategy", d: "Google & Meta campaigns with a clear plan to grow sales." },
  ],
  pricingTitle: "Simple, transparent pricing",
  pricingSub: "Pay as you go, or subscribe and let us handle everything. Prices in SEK, excl. VAT.",
  paygLabel: "Pay as you go",
  subLabel: "Monthly subscription",
  from: "from",
  popular: "Most popular",
  paygNames: ["Website", "Promo video", "Social post", "Ad campaign"],
  paygUnits: ["one-time", "one-time", "/ post", "/ mo + ad spend"],
  perMonth: "/ mo",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 social posts / month", "1 short video / month", "Website care & updates", "WhatsApp support"],
    ["10 posts + 2 videos / month", "Ad campaign management", "Monthly strategy call", "Priority WhatsApp support"],
    ["Unlimited content plan", "Weekly video production", "Full ads + funnel strategy", "Dedicated manager, same-day replies"],
  ],
  planCta: "Choose plan",
  dedTitle: "Your growth partner, always reachable",
  dedSub: "No call centres, no ticket queues. One dedicated person who knows your business and replies fast — on WhatsApp, email or a quick call.",
  dedCta: "Message us on WhatsApp",
  bookTitle: "Grab a free 15-minute call",
  bookSub: "See if we're a fit — no pressure, no jargon.",
  workLabel: "See it live",
  back: "Back to home",
  testiTitle: "Early wins from real businesses",
  testimonials: [
    { q: "NOWI rebuilt our site in two weeks and the bookings started coming in. A partner who just gets it done.", a: "Garden care", c: "Öland" },
    { q: "One person on WhatsApp who actually knows our business — no tickets, no waiting.", a: "Salon owner", c: "Sri Lanka" },
    { q: "Our video content looks like a big brand, on a small-business budget.", a: "Restaurant owner", c: "Stockholm" },
  ],
  onRequest: "On request",
  websitePrice: "499 kr",
  serviceCta: "Get started",
  formTitle: "Request a quote",
  formSub: "Tell us a little about your business and we'll reply within one business day.",
  formSelected: "Selected",
  waPrefill: "Hi NOWI! I'd like to grow my business.",
};

const sv = {
  seoTitle: "NOWI för småföretag — Webb, video & sociala medier som ger leads",
  seoDescription: "Webbplatser, video i toppklass och sociala medier skött av en dedikerad person som alltid är nåbar på WhatsApp. Betala per gång eller prenumerera.",
  badge: "För små och lokala företag",
  h1: ["Fler kunder.", "Mindre krångel."],
  sub: "Mer än webbplatser, mobilappar och video i toppklass — du får en dedikerad partner som är engagerad i att hjälpa ditt företag att växa. Varje projekt får en expert som förstår din vision och alltid är bara ett meddelande bort.",
  ctaBook: "Boka ett kostnadsfritt samtal",
  ctaWhats: "Chatta på WhatsApp",
  trust: ["Inget krångel", "Fast pris per tjänst", "Live på 2 veckor", "Avsluta när du vill*"],
  cancelNote: "*Exklusive webbappar och mobilappar.",
  apps: {
    title: "Mobilappar som får kunderna att återvända",
    sub: "Ge kunderna en anledning att öppna din app varje vecka.",
    items: [
      { t: "Digitala stämpelkort", d: "Lojalitets- och stämpelkort som i Pressbyråns app — köp nio, få den tionde gratis, direkt i mobilen." },
      { t: "Platsbaserade erbjudanden", d: "Känn av när en kund är i närheten, som Circle K, och skicka ett erbjudande om bränsle eller kaffe i rätt ögonblick." },
      { t: "Push-notiser", d: "Påminn kunderna med nyheter, erbjudanden och påminnelser så att ditt företag håller sig top of mind." },
    ],
    note: "Varumärkesexemplen visas endast som inspiration — de är inte byggda av NOWI.",
  },
  anniversary: {
    tag: "Jubileumserbjudande",
    title: "Vi firar — särskild lanseringsrabatt",
    text: "För att fira vårt jubileum ger vi nya kunder en begränsad introduktionsrabatt på webbprenumerationer och paket. Skriv till oss för att ta del av den innan den tar slut.",
    ends: "Erbjudandet slutar om",
    cta: "Ta del av erbjudandet",
  },
  whyTitle: "Därför väljer lokala företag NOWI",
  why: [
    { t: "Byggt för leads", d: "Varje sajt och kampanj byggs med ett mål: fler samtal, bokningar och försäljning." },
    { t: "En dedikerad person", d: "En riktig människa som kan ditt företag och är nåbar på WhatsApp när du behöver." },
    { t: "Video i toppklass", d: "Video och innehåll som fångar blicken — i en klass som brukar vara reserverad för stora varumärken." },
  ],
  offerTitle: "Allt för att växa online",
  offerSub: "Välj exakt det du behöver — eller låt oss sköta allt.",
  offers: [
    { t: "Webbplatser", d: "Snabba, moderna, mobil-först-sajter som gör besökare till kunder." },
    { t: "Promovideo", d: "Korta, slagkraftiga videor för sajt, annonser och sociala flöden." },
    { t: "Sociala medier", d: "Konsekvent innehåll i din ton som håller dig top of mind." },
    { t: "Annonser & strategi", d: "Google- och Meta-kampanjer med en tydlig plan för mer försäljning." },
  ],
  pricingTitle: "Enkel, transparent prissättning",
  pricingSub: "Betala per gång, eller prenumerera och låt oss sköta allt. Priser i SEK, exkl. moms.",
  paygLabel: "Betala per gång",
  subLabel: "Månadsprenumeration",
  from: "från",
  popular: "Populärast",
  paygNames: ["Webbplats", "Promovideo", "Socialt inlägg", "Annonskampanj"],
  paygUnits: ["engångs", "engångs", "/ inlägg", "/ mån + annonsbudget"],
  perMonth: "/ mån",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 inlägg / månad", "1 kort video / månad", "Webbunderhåll", "WhatsApp-support"],
    ["10 inlägg + 2 videor / månad", "Hantering av annonskampanjer", "Månatligt strategisamtal", "Prioriterad WhatsApp-support"],
    ["Obegränsad innehållsplan", "Veckovis videoproduktion", "Full annons- + funnel-strategi", "Dedikerad ansvarig, svar samma dag"],
  ],
  planCta: "Välj plan",
  dedTitle: "Din tillväxtpartner, alltid nåbar",
  dedSub: "Inga callcenter, inga ärendeköer. En dedikerad person som kan ditt företag och svarar snabbt — på WhatsApp, mejl eller ett snabbt samtal.",
  dedCta: "Skriv till oss på WhatsApp",
  bookTitle: "Boka ett kostnadsfritt 15-minuterssamtal",
  bookSub: "Se om vi passar ihop — inget tryck, inget krångel.",
  workLabel: "Se live",
  back: "Tillbaka till startsidan",
  testiTitle: "Tidiga resultat från riktiga företag",
  testimonials: [
    { q: "NOWI byggde om vår sajt på två veckor och bokningarna började komma in. Äntligen en partner som bara får det gjort.", a: "Trädgårdstjänst", c: "Öland" },
    { q: "En person på WhatsApp som faktiskt kan vårt företag — inga ärenden, ingen väntan.", a: "Salongsägare", c: "Sri Lanka" },
    { q: "Vårt videoinnehåll ser ut som ett stort varumärke, till en småföretagsbudget.", a: "Restaurangägare", c: "Stockholm" },
  ],
  onRequest: "På förfrågan",
  websitePrice: "499 kr",
  serviceCta: "Kom igång",
  formTitle: "Begär offert",
  formSub: "Berätta lite om ditt företag så svarar vi inom en arbetsdag.",
  formSelected: "Valt",
  waPrefill: "Hej NOWI! Jag vill växa mitt företag.",
};

const da = {
  seoTitle: "NOWI for små virksomheder — Web, video & sociale medier der giver leads",
  seoDescription: "Hjemmesider, video i topklasse og sociale medier styret af en dedikeret person, altid til at nå på WhatsApp. Betal pr. gang eller abonnér.",
  badge: "For små og lokale virksomheder",
  h1: ["Flere kunder.", "Mindre besvær."],
  sub: "Mere end hjemmesider, mobilapps og video i topklasse — du får en dedikeret partner, der er engageret i at hjælpe din virksomhed med at vokse. Hvert projekt får en ekspert, der forstår din vision og altid er kun én besked væk.",
  ctaBook: "Book en gratis samtale",
  ctaWhats: "Chat på WhatsApp",
  trust: ["Ingen jargon", "Fast pris pr. ydelse", "Live på 2 uger", "Opsig når som helst*"],
  cancelNote: "*Ekskl. webapps og mobilapps.",
  apps: {
    title: "Mobilapps, der får kunderne til at vende tilbage",
    sub: "Giv kunderne en grund til at åbne din app hver uge.",
    items: [
      { t: "Digitale stempelkort", d: "Loyalitets- og stempelkort som i Pressbyrån-appen — køb ni, få den tiende gratis, direkte på telefonen." },
      { t: "Placeringsbaserede tilbud", d: "Registrér, når en kunde er i nærheden, som Circle K, og send et tilbud på brændstof eller kaffe i rette øjeblik." },
      { t: "Push-notifikationer", d: "Mind kunderne om nyheder, tilbud og påmindelser, så din virksomhed forbliver top of mind." },
    ],
    note: "Brandeksempler vises kun som inspiration — de er ikke bygget af NOWI.",
  },
  anniversary: {
    tag: "Jubilæumstilbud",
    title: "Vi fejrer — særlig lanceringsrabat",
    text: "For at fejre vores jubilæum giver vi nye kunder en begrænset introduktionsrabat på webabonnementer og pakker. Skriv til os for at få den, før den er væk.",
    ends: "Tilbuddet slutter om",
    cta: "Få tilbuddet",
  },
  whyTitle: "Derfor vælger lokale virksomheder NOWI",
  why: [
    { t: "Bygget til leads", d: "Hver side og kampagne bygges med ét mål: flere opkald, bookinger og salg." },
    { t: "En dedikeret person", d: "Ét rigtigt menneske, der kender din virksomhed og er til at nå på WhatsApp." },
    { t: "Video i topklasse", d: "Video og indhold, der fanger blikket — i en klasse normalt forbeholdt store brands." },
  ],
  offerTitle: "Alt til at vokse online",
  offerSub: "Vælg præcis det, du har brug for — eller lad os styre det hele.",
  offers: [
    { t: "Hjemmesider", d: "Hurtige, moderne, mobil-først sider, der gør besøgende til kunder." },
    { t: "Promovideo", d: "Korte, slagkraftige videoer til side, annoncer og sociale feeds." },
    { t: "Sociale medier", d: "Konsistent indhold i din tone, der holder dig top of mind." },
    { t: "Annoncer & strategi", d: "Google- og Meta-kampagner med en klar plan for mere salg." },
  ],
  pricingTitle: "Enkel, gennemsigtig prissætning",
  pricingSub: "Betal pr. gang, eller abonnér og lad os klare det hele. Priser i SEK, ekskl. moms.",
  paygLabel: "Betal pr. gang",
  subLabel: "Månedligt abonnement",
  from: "fra",
  popular: "Mest populær",
  paygNames: ["Hjemmeside", "Promovideo", "Socialt opslag", "Annoncekampagne"],
  paygUnits: ["engangs", "engangs", "/ opslag", "/ md. + annoncebudget"],
  perMonth: "/ md.",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 opslag / måned", "1 kort video / måned", "Vedligehold af hjemmeside", "WhatsApp-support"],
    ["10 opslag + 2 videoer / måned", "Styring af annoncekampagner", "Månedlig strategisamtale", "Prioriteret WhatsApp-support"],
    ["Ubegrænset indholdsplan", "Ugentlig videoproduktion", "Fuld annonce- + funnel-strategi", "Dedikeret ansvarlig, svar samme dag"],
  ],
  planCta: "Vælg plan",
  dedTitle: "Din vækstpartner, altid til at nå",
  dedSub: "Ingen callcentre, ingen sagskøer. Én dedikeret person, der kender din virksomhed og svarer hurtigt — på WhatsApp, mail eller et hurtigt opkald.",
  dedCta: "Skriv til os på WhatsApp",
  bookTitle: "Book en gratis 15-minutters samtale",
  bookSub: "Se om vi passer sammen — ingen pres, ingen jargon.",
  workLabel: "Se live",
  back: "Tilbage til forsiden",
  testiTitle: "Tidlige resultater fra rigtige virksomheder",
  testimonials: [
    { q: "NOWI byggede vores side om på to uger, og bookingerne begyndte at komme. Endelig en partner, der bare får det gjort.", a: "Havepleje", c: "Öland" },
    { q: "Én person på WhatsApp, der faktisk kender vores forretning — ingen sager, ingen ventetid.", a: "Salonejer", c: "Sri Lanka" },
    { q: "Vores videoindhold ligner et stort brand, til et budget for små virksomheder.", a: "Restaurantejer", c: "Stockholm" },
  ],
  onRequest: "På forespørgsel",
  websitePrice: "329 kr",
  serviceCta: "Kom i gang",
  formTitle: "Anmod om tilbud",
  formSub: "Fortæl lidt om din virksomhed, så svarer vi inden for én arbejdsdag.",
  formSelected: "Valgt",
  waPrefill: "Hej NOWI! Jeg vil gerne vokse min virksomhed.",
};

const nb = {
  seoTitle: "NOWI for småbedrifter — Nett, video & sosiale medier som gir leads",
  seoDescription: "Nettsider, video i toppklasse og sosiale medier styrt av en dedikert person som alltid er tilgjengelig på WhatsApp. Betal per gang eller abonner.",
  badge: "For små og lokale bedrifter",
  h1: ["Flere kunder.", "Mindre styr."],
  sub: "Mer enn nettsider, mobil-apper og video i toppklasse — du får en dedikert partner som er engasjert i å hjelpe bedriften din å vokse. Hvert prosjekt får en ekspert som forstår visjonen din og alltid er bare én melding unna.",
  ctaBook: "Book en gratis samtale",
  ctaWhats: "Chat på WhatsApp",
  trust: ["Ingen sjargong", "Fast pris per tjeneste", "Live på 2 uker", "Avslutt når du vil*"],
  cancelNote: "*Ekskl. web-apper og mobil-apper.",
  apps: {
    title: "Mobil-apper som får kundene til å komme tilbake",
    sub: "Gi kundene en grunn til å åpne appen din hver uke.",
    items: [
      { t: "Digitale stempelkort", d: "Lojalitets- og stempelkort som i Pressbyrån-appen — kjøp ni, få den tiende gratis, rett på telefonen." },
      { t: "Stedsbaserte tilbud", d: "Oppdag når en kunde er i nærheten, som Circle K, og send et tilbud på drivstoff eller kaffe i rett øyeblikk." },
      { t: "Push-varsler", d: "Minn kundene på nyheter, tilbud og påminnelser så bedriften din holder seg top of mind." },
    ],
    note: "Merkevareeksemplene vises kun som inspirasjon — de er ikke bygget av NOWI.",
  },
  anniversary: {
    tag: "Jubileumstilbud",
    title: "Vi feirer — spesiell lanseringsrabatt",
    text: "For å feire jubileet gir vi nye kunder en begrenset introduksjonsrabatt på nettabonnementer og pakker. Skriv til oss for å benytte den før den er borte.",
    ends: "Tilbudet slutter om",
    cta: "Benytt tilbudet",
  },
  whyTitle: "Derfor velger lokale bedrifter NOWI",
  why: [
    { t: "Bygget for leads", d: "Hver side og kampanje bygges med ett mål: flere anrop, bookinger og salg." },
    { t: "En dedikert person", d: "Ett ekte menneske som kjenner bedriften din og er tilgjengelig på WhatsApp." },
    { t: "Video i toppklasse", d: "Video og innhold som fanger blikket — i en klasse vanligvis forbeholdt store merkevarer." },
  ],
  offerTitle: "Alt for å vokse på nett",
  offerSub: "Velg akkurat det du trenger — eller la oss styre alt.",
  offers: [
    { t: "Nettsider", d: "Raske, moderne, mobil-først-sider som gjør besøkende til kunder." },
    { t: "Promovideo", d: "Korte, slagkraftige videoer for nettside, annonser og sosiale feeder." },
    { t: "Sosiale medier", d: "Konsistent innhold i din tone som holder deg top of mind." },
    { t: "Annonser & strategi", d: "Google- og Meta-kampanjer med en tydelig plan for mer salg." },
  ],
  pricingTitle: "Enkel, transparent prising",
  pricingSub: "Betal per gang, eller abonner og la oss ta oss av alt. Priser i SEK, eks. mva.",
  paygLabel: "Betal per gang",
  subLabel: "Månedlig abonnement",
  from: "fra",
  popular: "Mest populær",
  paygNames: ["Nettside", "Promovideo", "Sosialt innlegg", "Annonsekampanje"],
  paygUnits: ["engangs", "engangs", "/ innlegg", "/ mnd + annonsebudsjett"],
  perMonth: "/ mnd",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 innlegg / måned", "1 kort video / måned", "Vedlikehold av nettside", "WhatsApp-støtte"],
    ["10 innlegg + 2 videoer / måned", "Styring av annonsekampanjer", "Månedlig strategisamtale", "Prioritert WhatsApp-støtte"],
    ["Ubegrenset innholdsplan", "Ukentlig videoproduksjon", "Full annonse- + funnel-strategi", "Dedikert ansvarlig, svar samme dag"],
  ],
  planCta: "Velg plan",
  dedTitle: "Din vekstpartner, alltid tilgjengelig",
  dedSub: "Ingen callsentre, ingen sakskøer. Én dedikert person som kjenner bedriften din og svarer raskt — på WhatsApp, e-post eller en rask samtale.",
  dedCta: "Skriv til oss på WhatsApp",
  bookTitle: "Book en gratis 15-minutters samtale",
  bookSub: "Se om vi passer sammen — ingen press, ingen sjargong.",
  workLabel: "Se live",
  back: "Tilbake til forsiden",
  testiTitle: "Tidlige resultater fra ekte bedrifter",
  testimonials: [
    { q: "NOWI bygde om nettsiden vår på to uker, og bookingene begynte å komme. Endelig en partner som bare får det gjort.", a: "Hagepleie", c: "Öland" },
    { q: "Én person på WhatsApp som faktisk kjenner bedriften vår — ingen saker, ingen venting.", a: "Saloneier", c: "Sri Lanka" },
    { q: "Videoinnholdet vårt ser ut som et stort merke, til et småbedriftsbudsjett.", a: "Restauranteier", c: "Stockholm" },
  ],
  onRequest: "På forespørsel",
  websitePrice: "529 kr",
  serviceCta: "Kom i gang",
  formTitle: "Be om tilbud",
  formSub: "Fortell litt om bedriften din, så svarer vi innen én virkedag.",
  formSelected: "Valgt",
  waPrefill: "Hei NOWI! Jeg vil vokse bedriften min.",
};

const fi = {
  seoTitle: "NOWI pienyrityksille — Verkkosivut, video & some jotka tuovat liidit",
  seoDescription: "Verkkosivut, huippuluokan video ja sosiaalinen media, joita hoitaa oma yhteyshenkilö aina tavoitettavissa WhatsAppissa. Maksa käytön mukaan tai tilaa.",
  badge: "Pienille ja paikallisille yrityksille",
  h1: ["Enemmän asiakkaita.", "Vähemmän vaivaa."],
  sub: "Enemmän kuin verkkosivut, mobiilisovellukset ja huippuluokan video — saat omistautuneen kumppanin, joka on sitoutunut auttamaan yritystäsi kasvamaan. Jokaiseen projektiin kuuluu asiantuntija, joka ymmärtää visiosi ja on aina vain yhden viestin päässä.",
  ctaBook: "Varaa maksuton puhelu",
  ctaWhats: "Chattaa WhatsAppissa",
  trust: ["Ei jargonia", "Kiinteä hinta per palvelu", "Live 2 viikossa", "Peru milloin vain*"],
  cancelNote: "*Pois lukien verkkosovellukset ja mobiilisovellukset.",
  apps: {
    title: "Mobiilisovellukset, jotka tuovat asiakkaat takaisin",
    sub: "Anna asiakkaille syy avata sovelluksesi joka viikko.",
    items: [
      { t: "Digitaaliset leimakortit", d: "Kanta- ja leimakortit kuten Pressbyrånin sovelluksessa — osta yhdeksän, saat kymmenennen ilmaiseksi, suoraan puhelimessa." },
      { t: "Sijaintiperustaiset tarjoukset", d: "Tunnista, kun asiakas on lähellä, kuten Circle K, ja lähetä oikea-aikainen polttoaine- tai kahvitarjous." },
      { t: "Push-ilmoitukset", d: "Muistuta asiakkaita uutisista, tarjouksista ja muistutuksista, jotta yrityksesi pysyy mielessä." },
    ],
    note: "Brändiesimerkit näytetään vain inspiraationa — NOWI ei ole rakentanut niitä.",
  },
  anniversary: {
    tag: "Juhlatarjous",
    title: "Juhlimme — erityinen lanseerausalennus",
    text: "Juhlistaaksemme vuosipäivää tarjoamme uusille asiakkaille rajoitetun tutustumisalennuksen verkkotilauksista ja paketeista. Lunasta se viestittämällä meille ennen kuin se loppuu.",
    ends: "Tarjous päättyy",
    cta: "Lunasta tarjous",
  },
  whyTitle: "Miksi paikalliset yritykset valitsevat NOWIn",
  why: [
    { t: "Rakennettu liideille", d: "Jokainen sivu ja kampanja rakennetaan yhtä tavoitetta varten: enemmän soittoja, varauksia ja myyntiä." },
    { t: "Oma yhteyshenkilö", d: "Yksi oikea ihminen, joka tuntee yrityksesi ja on tavoitettavissa WhatsAppissa." },
    { t: "Huippuluokan video", d: "Katseen pysäyttävä video ja sisältö — tasolla, joka on yleensä varattu suurille brändeille." },
  ],
  offerTitle: "Kaikki verkossa kasvamiseen",
  offerSub: "Valitse juuri se mitä tarvitset — tai anna meidän hoitaa kaikki.",
  offers: [
    { t: "Verkkosivut", d: "Nopeat, modernit, mobiili edellä -sivut, jotka muuttavat kävijät asiakkaiksi." },
    { t: "Promovideo", d: "Lyhyet, iskevät videot sivulle, mainoksiin ja someen." },
    { t: "Sosiaalinen media", d: "Johdonmukainen, brändinmukainen sisältö, joka pitää sinut mielessä." },
    { t: "Mainonta & strategia", d: "Google- ja Meta-kampanjat selkeällä myynnin kasvusuunnitelmalla." },
  ],
  pricingTitle: "Selkeä, läpinäkyvä hinnoittelu",
  pricingSub: "Maksa käytön mukaan tai tilaa ja anna meidän hoitaa kaikki. Hinnat SEK, ilman alv.",
  paygLabel: "Maksa käytön mukaan",
  subLabel: "Kuukausitilaus",
  from: "alkaen",
  popular: "Suosituin",
  paygNames: ["Verkkosivu", "Promovideo", "Some-julkaisu", "Mainoskampanja"],
  paygUnits: ["kertamaksu", "kertamaksu", "/ julkaisu", "/ kk + mainosbudjetti"],
  perMonth: "/ kk",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 julkaisua / kk", "1 lyhyt video / kk", "Sivuston ylläpito", "WhatsApp-tuki"],
    ["10 julkaisua + 2 videota / kk", "Mainoskampanjoiden hallinta", "Kuukausittainen strategiapuhelu", "Priorisoitu WhatsApp-tuki"],
    ["Rajaton sisältösuunnitelma", "Viikoittainen videotuotanto", "Täysi mainos- + funnel-strategia", "Oma vastuuhenkilö, vastaus samana päivänä"],
  ],
  planCta: "Valitse paketti",
  dedTitle: "Kasvukumppanisi, aina tavoitettavissa",
  dedSub: "Ei puhelinkeskuksia, ei jonoja. Yksi oma yhteyshenkilö, joka tuntee yrityksesi ja vastaa nopeasti — WhatsAppissa, sähköpostitse tai puhelimitse.",
  dedCta: "Kirjoita meille WhatsAppissa",
  bookTitle: "Varaa maksuton 15 minuutin puhelu",
  bookSub: "Katso sopimmeko yhteen — ei painostusta, ei jargonia.",
  workLabel: "Katso live",
  back: "Takaisin etusivulle",
  testiTitle: "Ensimmäisiä tuloksia oikeilta yrityksiltä",
  testimonials: [
    { q: "NOWI rakensi sivustomme uudelleen kahdessa viikossa ja varaukset alkoivat tulla. Vihdoin kumppani, joka vain hoitaa asian.", a: "Puutarhanhoito", c: "Öland" },
    { q: "Yksi ihminen WhatsAppissa, joka oikeasti tuntee yrityksemme — ei tikettejä, ei odottelua.", a: "Kampaamon omistaja", c: "Sri Lanka" },
    { q: "Videosisältömme näyttää suurelta brändiltä pienyrityksen budjetilla.", a: "Ravintolan omistaja", c: "Tukholma" },
  ],
  onRequest: "Pyynnöstä",
  websitePrice: "€45",
  serviceCta: "Aloita",
  formTitle: "Pyydä tarjous",
  formSub: "Kerro hieman yrityksestäsi, niin vastaamme yhden arkipäivän kuluessa.",
  formSelected: "Valittu",
  waPrefill: "Hei NOWI! Haluan kasvattaa yritystäni.",
};

const is = {
  seoTitle: "NOWI fyrir lítil fyrirtæki — Vefsíður, myndbönd & samfélagsmiðlar",
  seoDescription: "Vefsíður, fyrsta flokks myndbönd og samfélagsmiðlar í umsjón sérstaks tengiliðs sem alltaf næst á WhatsApp. Borgaðu eftir notkun eða áskrift.",
  badge: "Fyrir lítil og staðbundin fyrirtæki",
  h1: ["Fleiri viðskiptavinir.", "Minna vesen."],
  sub: "Meira en vefsíður, smáforrit og fyrsta flokks myndbönd — þú færð sérstakan samstarfsaðila sem er staðráðinn í að hjálpa fyrirtækinu þínu að vaxa. Hverju verkefni fylgir sérfræðingur sem skilur sýn þína og er alltaf aðeins einu skilaboði í burtu.",
  ctaBook: "Bókaðu ókeypis símtal",
  ctaWhats: "Spjallaðu á WhatsApp",
  trust: ["Ekkert hrognamál", "Fast verð fyrir hverja þjónustu", "Í loftið á 2 vikum", "Segðu upp hvenær sem er*"],
  cancelNote: "*Að undanskildum vefforritum og smáforritum.",
  apps: {
    title: "Smáforrit sem halda viðskiptavinum við efnið",
    sub: "Gefðu fólki ástæðu til að opna appið þitt í hverri viku.",
    items: [
      { t: "Stafræn stimpilkort", d: "Tryggðar- og stimpilkort eins og í Pressbyrån-appinu — keyptu níu, fáðu það tíunda frítt, beint í símanum." },
      { t: "Staðsetningartilboð", d: "Skynjaðu þegar viðskiptavinur er nálægt, eins og Circle K, og sendu tímabært tilboð um eldsneyti eða kaffi." },
      { t: "Push-tilkynningar", d: "Minntu viðskiptavini á fréttir, tilboð og áminningar svo fyrirtækið þitt haldist ofarlega í huga." },
    ],
    note: "Vörumerkjadæmin eru sýnd eingöngu til innblásturs — þau eru ekki smíðuð af NOWI.",
  },
  anniversary: {
    tag: "Afmælistilboð",
    title: "Við fögnum — sérstakur kynningarafsláttur",
    text: "Til að fagna afmælinu bjóðum við nýjum viðskiptavinum takmarkaðan kynningarafslátt af vefáskriftum og pökkum. Sendu okkur skilaboð til að nýta hann áður en hann klárast.",
    ends: "Tilboð lýkur eftir",
    cta: "Nýttu tilboðið",
  },
  whyTitle: "Af hverju velja staðbundin fyrirtæki NOWI",
  why: [
    { t: "Byggt fyrir viðskipti", d: "Hver síða og herferð er hönnuð með eitt markmið: fleiri símtöl, bókanir og sölu." },
    { t: "Sérstakur tengiliður", d: "Ein raunveruleg manneskja sem þekkir fyrirtækið þitt og næst á WhatsApp." },
    { t: "Fyrsta flokks myndbönd", d: "Myndbönd og efni sem grípa augað — í gæðaflokki sem venjulega er frátekinn stórum vörumerkjum." },
  ],
  offerTitle: "Allt til að vaxa á netinu",
  offerSub: "Veldu nákvæmlega það sem þú þarft — eða láttu okkur sjá um allt.",
  offers: [
    { t: "Vefsíður", d: "Hraðar, nútímalegar, farsíma-fyrst síður sem breyta gestum í viðskiptavini." },
    { t: "Kynningarmyndband", d: "Stutt, kröftug myndbönd fyrir síðuna, auglýsingar og samfélagsmiðla." },
    { t: "Samfélagsmiðlar", d: "Samræmt efni í þínum tón sem heldur þér í huga fólks." },
    { t: "Auglýsingar & stefna", d: "Google- og Meta-herferðir með skýrri áætlun um aukna sölu." },
  ],
  pricingTitle: "Einfalt, gagnsætt verð",
  pricingSub: "Borgaðu eftir notkun, eða gerðu áskrift og láttu okkur sjá um allt. Verð í SEK, án vsk.",
  paygLabel: "Borga eftir notkun",
  subLabel: "Mánaðaráskrift",
  from: "frá",
  popular: "Vinsælast",
  paygNames: ["Vefsíða", "Kynningarmyndband", "Færsla", "Auglýsingaherferð"],
  paygUnits: ["eitt gjald", "eitt gjald", "/ færsla", "/ mán + auglýsingakostnaður"],
  perMonth: "/ mán",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 færslur / mánuði", "1 stutt myndband / mánuði", "Umsjón vefsíðu", "WhatsApp-aðstoð"],
    ["10 færslur + 2 myndbönd / mánuði", "Umsjón auglýsingaherferða", "Mánaðarlegt stefnusímtal", "Forgangs WhatsApp-aðstoð"],
    ["Ótakmörkuð efnisáætlun", "Vikuleg myndbandaframleiðsla", "Full auglýsinga- + funnel-stefna", "Sérstakur umsjónarmaður, svar samdægurs"],
  ],
  planCta: "Velja pakka",
  dedTitle: "Vaxtarfélagi þinn, alltaf til taks",
  dedSub: "Engar símaver, engar biðraðir. Einn sérstakur tengiliður sem þekkir fyrirtækið þitt og svarar fljótt — á WhatsApp, í tölvupósti eða stuttu símtali.",
  dedCta: "Skrifaðu okkur á WhatsApp",
  bookTitle: "Bókaðu ókeypis 15 mínútna símtal",
  bookSub: "Sjáðu hvort við eigum samleið — enginn þrýstingur, ekkert hrognamál.",
  workLabel: "Skoða live",
  back: "Til baka á forsíðu",
  testiTitle: "Fyrstu árangrar frá alvöru fyrirtækjum",
  testimonials: [
    { q: "NOWI endurbyggði síðuna okkar á tveimur vikum og bókanir byrjuðu að berast. Loksins samstarfsaðili sem bara klárar málið.", a: "Garðþjónusta", c: "Öland" },
    { q: "Ein manneskja á WhatsApp sem þekkir raunverulega fyrirtækið okkar — engin mál, engin bið.", a: "Hárgreiðslustofueigandi", c: "Srí Lanka" },
    { q: "Myndbandsefnið okkar lítur út eins og stórt vörumerki, á fjárhagsáætlun lítils fyrirtækis.", a: "Veitingahúsaeigandi", c: "Stokkhólmi" },
  ],
  onRequest: "Eftir samkomulagi",
  websitePrice: "6 900 kr",
  serviceCta: "Byrja",
  formTitle: "Biðja um tilboð",
  formSub: "Segðu okkur aðeins frá fyrirtækinu þínu og við svörum innan eins virks dags.",
  formSelected: "Valið",
  waPrefill: "Halló NOWI! Ég vil stækka fyrirtækið mitt.",
};

const de = {
  seoTitle: "NOWI für kleine Unternehmen — Websites, Video & Social für mehr Leads",
  seoDescription: "Websites, Video in Industriequalität und Social Media, betreut von einer festen Ansprechperson, immer per WhatsApp erreichbar. Pay-as-you-go oder Abo.",
  badge: "Für kleine und lokale Unternehmen",
  h1: ["Mehr Kunden.", "Weniger Aufwand."],
  sub: "Mehr als Websites, mobile Apps und Video in Industriequalität — Sie erhalten einen engagierten Partner, der Ihr Unternehmen beim Wachsen unterstützt. Zu jedem Projekt gehört ein Experte, der Ihre Vision versteht und immer nur eine Nachricht entfernt ist.",
  ctaBook: "Kostenloses Gespräch buchen",
  ctaWhats: "Auf WhatsApp chatten",
  trust: ["Kein Fachjargon", "Festpreis pro Leistung", "In 2 Wochen live", "Jederzeit kündbar*"],
  cancelNote: "*Ausgenommen Web-Apps und mobile Apps.",
  apps: {
    title: "Mobile Apps, die Kunden zurückbringen",
    sub: "Geben Sie Kunden einen Grund, Ihre App jede Woche zu öffnen.",
    items: [
      { t: "Digitale Stempelkarten", d: "Treue- und Stempelkarten wie in der Pressbyrån-App — neun kaufen, das zehnte gratis, direkt aufs Handy." },
      { t: "Standortbasierte Angebote", d: "Erkennen Sie, wenn ein Kunde in der Nähe ist, wie Circle K, und senden Sie ein passendes Kraftstoff- oder Kaffeeangebot." },
      { t: "Push-Benachrichtigungen", d: "Erinnern Sie Kunden an News, Angebote und Hinweise, damit Ihr Geschäft im Kopf bleibt." },
    ],
    note: "Markenbeispiele dienen nur der Inspiration — sie wurden nicht von NOWI entwickelt.",
  },
  anniversary: {
    tag: "Jubiläumsangebot",
    title: "Wir feiern — besonderer Einführungsrabatt",
    text: "Zu unserem Jubiläum erhalten Neukunden einen begrenzten Einführungsrabatt auf Web-Abos und Pakete. Schreiben Sie uns, um ihn zu sichern, bevor er weg ist.",
    ends: "Angebot endet in",
    cta: "Angebot sichern",
  },
  whyTitle: "Warum lokale Unternehmen NOWI wählen",
  why: [
    { t: "Für Leads gebaut", d: "Jede Website und Kampagne verfolgt ein Ziel: mehr Anrufe, Buchungen und Umsatz." },
    { t: "Eine feste Ansprechperson", d: "Ein echter Mensch, der Ihr Geschäft kennt und per WhatsApp erreichbar ist." },
    { t: "Video in Industriequalität", d: "Aufmerksamkeitsstarkes Video und Content — in einer Qualität, die sonst großen Marken vorbehalten ist." },
  ],
  offerTitle: "Alles, um online zu wachsen",
  offerSub: "Wählen Sie genau, was Sie brauchen — oder wir übernehmen alles.",
  offers: [
    { t: "Websites", d: "Schnelle, moderne, mobile-first Websites, die Besucher zu Kunden machen." },
    { t: "Promo-Video", d: "Kurze, prägnante Videos für Website, Anzeigen und Social Feeds." },
    { t: "Social Media", d: "Konsistenter, markengerechter Content, der Sie im Kopf bleiben lässt." },
    { t: "Ads & Strategie", d: "Google- & Meta-Kampagnen mit klarem Plan für mehr Umsatz." },
  ],
  pricingTitle: "Einfache, transparente Preise",
  pricingSub: "Pay-as-you-go oder Abo — wir übernehmen alles. Preise in SEK, zzgl. MwSt.",
  paygLabel: "Pay as you go",
  subLabel: "Monatliches Abo",
  from: "ab",
  popular: "Am beliebtesten",
  paygNames: ["Website", "Promo-Video", "Social-Post", "Werbekampagne"],
  paygUnits: ["einmalig", "einmalig", "/ Post", "/ Mon. + Werbebudget"],
  perMonth: "/ Mon.",
  planNames: ["Starter", "Growth", "Pro"],
  planFeatures: [
    ["4 Posts / Monat", "1 kurzes Video / Monat", "Website-Pflege", "WhatsApp-Support"],
    ["10 Posts + 2 Videos / Monat", "Verwaltung der Werbekampagnen", "Monatliches Strategiegespräch", "Priorisierter WhatsApp-Support"],
    ["Unbegrenzter Content-Plan", "Wöchentliche Videoproduktion", "Volle Ads- + Funnel-Strategie", "Feste Ansprechperson, Antwort am selben Tag"],
  ],
  planCta: "Plan wählen",
  dedTitle: "Ihr Wachstumspartner, immer erreichbar",
  dedSub: "Keine Callcenter, keine Ticket-Warteschlangen. Eine feste Ansprechperson, die Ihr Geschäft kennt und schnell antwortet — per WhatsApp, E-Mail oder kurzem Anruf.",
  dedCta: "Schreiben Sie uns auf WhatsApp",
  bookTitle: "Kostenloses 15-Minuten-Gespräch sichern",
  bookSub: "Sehen Sie, ob wir zusammenpassen — kein Druck, kein Fachjargon.",
  workLabel: "Live ansehen",
  back: "Zurück zur Startseite",
  testiTitle: "Erste Erfolge von echten Unternehmen",
  testimonials: [
    { q: "NOWI hat unsere Website in zwei Wochen neu gebaut und die Buchungen kamen. Endlich ein Partner, der es einfach umsetzt.", a: "Gartenpflege", c: "Öland" },
    { q: "Eine Person auf WhatsApp, die unser Geschäft wirklich kennt — keine Tickets, kein Warten.", a: "Salon-Inhaberin", c: "Sri Lanka" },
    { q: "Unser Video-Content sieht aus wie eine große Marke, zum Budget eines kleinen Unternehmens.", a: "Restaurant-Inhaber", c: "Stockholm" },
  ],
  onRequest: "Auf Anfrage",
  websitePrice: "€45",
  serviceCta: "Loslegen",
  formTitle: "Angebot anfordern",
  formSub: "Erzählen Sie uns kurz von Ihrem Unternehmen — wir antworten innerhalb eines Werktags.",
  formSelected: "Ausgewählt",
  waPrefill: "Hallo NOWI! Ich möchte mein Unternehmen wachsen lassen.",
};

export const smeContent = { en, sv, da, nb, fi, is, de };
